import React from "react";
import { useParams } from "react-router-dom";
import DetailComponent from "../components/detail/detail.component";

const Detail: React.FC = () => {
    const { id } = useParams(); // Get the dynamic :id parameter

    return (
        <>
            <DetailComponent id={id}></DetailComponent>
        </>
        // 
    );
};

export default Detail;
